module.exports = __webpack_public_path__ + "static/media/4.2ca9ff72.jpg";